{
  "general": {
    "title": "Información general",
    "description": "Administre los datos clave de su organización, como el nombre, el nombre de la entidad y los enlaces de soporte. Configure la visibilidad del centro de ayuda y proporcione una URL de soporte para la asistencia al cliente.",
    "organizationName": "Nombre de la organización",
    "entityName": "Nombre de la entidad",
    "supportUrl": "URL de soporte",
    "viewHelpCenter": "Ver Centro de ayuda",
    "helpCenterUrl": "URL del Centro de ayuda",
    "parent": "Organización matriz",
    "subdomain": "Subdominio",
    "id": "ID",
    "enableContactSupport": "Habilitar soporte técnico",
    "enableResourcesAndArticles": "Habilitar recursos y artículos",
    "helpCentreUrl": "URL del Centro de ayuda",
    "urlError": "URL no válida"
  },
  "designer": {
    "title": "Diseñador",
    "description": "Personalice la identidad visual de su plataforma: actualice logotipos, enlaces de favicons y títulos de pestañas del navegador. Elija si desea heredar el estilo de la organización principal o aplicar elementos de marca únicos.",
    "faviconLink": "Enlace al favicon",
    "faviconLinkHelpText": "El enlace del favicon es la URL de la imagen del favicon. El favicon es el pequeño ícono que aparece en la pestaña del navegador.",
    "browserTabTitle": "Título de la pestaña del navegador",
    "example": "Ejemplo",
    "exampleTitle": "Título de ejemplo",
    "exampleDescription": "Así se verá el diseño",
    "topBarColor": "Color de la barra superior",
    "topBarTextColor": "Color del texto de la barra superior",
    "primaryColor": "Color principal",
    "buttonBorderRadius": "Radio del borde del botón",
    "pageBackgroundColor": "Color de fondo de la página",
    "borderRadiusRound": "Circular",
    "borderRadiusLarge": "Grande",
    "borderRadiusMedium": "Medio",
    "borderRadiusNone": "Ninguno",
    "borderRadiusSmall": "Chico",
    "cardBorderRadius": "Radio del borde de la tarjeta",
    "logo": "Logotipo",
    "moreChanges": "Si desea realizar cambios más profundos en el diseño de su plataforma, póngase en contacto con su administrador.",
    "useParentThemeTokens": "Heredar estilo de la organización principal",
    "colorError": "Código hexadecimal de color no válido"
  },
  "authenticationDesigner": {
    "title": "Diseñador de autenticación",
    "description": "Personalice la página de inicio de sesión: configure un logotipo, un color principal y un color de fondo que se ajusten a la imagen de marca de su organización.",
    "logoLink": "URL del logotipo (flujo de autenticación)",
    "logoLinkHelpText": "Este es un enlace a la imagen del logotipo que se mostrará en la página de inicio de sesión.",
    "primaryColor": "Color principal (flujo de autenticación)",
    "pageBackgroundColor": "Color de fondo de la página (flujo de autenticación)"
  },
  "errorPageDesigner": {
    "title": "Página de error",
    "description": "Personalice la página de error: defina el mensaje, la descripción y la etiqueta del botón. Ajuste el color de fondo y elija si desea mostrar la barra de navegación.",
    "errorPageMessage": "Mensaje de error",
    "errorPageDescription": "Descripción del error",
    "errorPageButtonText": "Texto del botón",
    "errorPageBackgroundColor": "Color de fondo",
    "errorPageShowNavbar": "Mostrar barra de navegación"
  },
  "accessUsers": {
    "title": "Acceso de usuarios",
    "description": "Agregue y administre usuarios con acceso a la plataforma. Asigne roles, defina niveles de acceso y administre invitaciones."
  },
  "authentication": {
    "title": "Autenticación",
    "description": "Configure los ajustes de autenticación, incluidos los métodos de inicio de sesión, las URL de redireccionamiento personalizadas y las opciones de autenticación multifactorial para mejorar la seguridad.",
    "customUrl": "Personalizar URL",
    "enableSingleLogout": "Habilitar el cierre de sesión único",
    "logoutRedirectUrl": "URL de redireccionamiento al cerrar sesión",
    "defaultAuthenticationConnection": "Autenticación predeterminada",
    "enableMultiFactorAuthentication": "Habilitar la autenticación de múltiples factores",
    "defaultAuthenticationConnectionOptions": {
      "EMAIL_AND_PASSWORD": "Correo electrónico y contraseña",
      "EMAIL_OTP": "Correo electrónico: código de un solo uso (sin contraseña)",
      "ENTERPRISE": "SSO empresarial"
    },
    "multiFactorAuthenticationTitle": "Opciones de autenticación de múltiples factores",
    "multiFactorAuthenticationOptions": {
      "EMAIL": "Correo electrónico",
      "SMS": "Mensaje SMS",
      "AUTHENTICATOR": "Autenticador"
    },
    "termsAndConditionsUrl": "URL de los Términos y condiciones",
    "auth0DisplayName": "Mostrar nombre",
    "enableLoginSettings": "Habilitar configuración de inicio de sesión",
    "loginSettingsTitle": "Título",
    "loginUrl": "URL para iniciar sesión",
    "customUrlHelpText": "Antes de actualizar este campo, asegúrese de que el CNAME haya sido configurado por el equipo de CloudOps",
    "logoutRedirectUrlHelpText": "Antes de actualizar este campo, asegúrese de que se haya actualizado en auth0"
  },
  "roles": {
    "title": "Roles",
    "description": "Administre y configure roles dentro de la plataforma. Asigne perfiles de roles, defina permisos y personalice estilos de navegación para alinearlos con las responsabilidades y necesidades de acceso de los usuarios."
  },
  "roleProfiles": {
    "title": "Perfiles de roles",
    "description": "Cree y administre perfiles de roles para definir los permisos de los usuarios y los niveles de acceso. Configure los estilos de navegación, el acceso a las páginas y los permisos específicos para adaptarse a las necesidades de la organización.",
    "useParentRoleProfiles": "Heredar perfiles de roles de la organización principal"
  },
  "accessSettings": {
    "title": "Configuración de acceso",
    "description": "Defina reglas de acceso de usuarios, como permisos para suborganizaciones, opciones de cierre de sesión, invitaciones automáticas a usuarios y tiempos de espera por inactividad para mejorar la seguridad.",
    "allowAccessToSubOrganizations": "Permitir el acceso a suborganizaciones",
    "allowLogout": "Permitir cerrar sesión",
    "autoInviteImportedUsers": "Invitar automáticamente a los usuarios importados",
    "enableInactivityTimeOut": "Habilitar tiempo de espera por inactividad",
    "inactivityTimeoutInMinutes": "Tiempo de inactividad (en minutos)",
    "enableEmailFrenchTranslation": "Habilitar traducción de correo electrónico al francés"
  },
  "dashboards": {
    "title": "Paneles de control",
    "description": "Cree y administre paneles para mostrar indicadores clave de rendimiento, métricas y visualizaciones de datos. Personalice los diseños de los paneles, los widgets y las fuentes de datos para alinearlos con los objetivos de la organización y los requisitos de generación de informes."
  },
  "notificationGroups": {
    "title": "Grupos de notificaciones",
    "description": "Cree y administre grupos de notificaciones para definir cómo reciben las alertas los usuarios. Configure notificaciones en la aplicación, push, por correo electrónico y webhook, y establezca estados predeterminados para las preferencias de los usuarios.",
    "useParentNotificationGroups": "Heredar grupos de notificación de la organización principal"
  },
  "notificationDefinitions": {
    "title": "Definiciones de las notificaciones",
    "description": "Defina eventos de notificación específicos y configure plantillas de mensajes. Asigne notificaciones a grupos, establezca eventos activadores y personalice los métodos de entrega, incluidas las notificaciones en la aplicación, por correo electrónico y webhook.",
    "useParentNotificationDefinitions": "Heredar definiciones de notificación de la organización principal"
  },
  "forms": {
    "title": "Formularios",
    "description": "Cree y administre formularios para firmar acuerdos, recopilar información de los usuarios y administrar los datos de los clientes.",
    "useParentFormTemplates": "Heredar plantillas de formulario de la organización principal"
  },
  "localization": {
    "title": "Localización",
    "description": "Configure los ajustes específicos de cada región, como las jurisdicciones habilitadas, los formatos de identificación fiscal y las preferencias de visualización de la moneda, para garantizar el cumplimiento normativo y la coherencia en todos los mercados.",
    "displayCurrency": "Mostrar la moneda en toda la plataforma",
    "localization": "Localización",
    "noLocalization": "ninguno (se aplican los valores predeterminados)",
    "country": "país",
    "currency": "moneda",
    "productShelfCurrencies": "Monedas en el Estante de productos",
    "baseCurrency": "Moneda base"
  },
  "notifications": {
    "groups": "Grupos",
    "definitions": "Definiciones"
  },
  "statementsAndTaxDocuments": {
    "title": "Estados de cuenta y documentos fiscales",
    "description": "Configure el acceso a los informes, acuerdos y documentos financieros de los clientes. Active o desactive los estados de cuenta, acuerdos y documentos fiscales de OneVest y del custodio en función de las preferencias de la organización."
  },
  "repCodes": {
    "title": "Códigos de representante",
    "description": "Crear y administrar códigos de representante.",
    "useParentRepCodes": "Heredar códigos de representante de la organización principal"
  },
  "pageConfigurations": {
    "title": "Configuraciones de página",
    "description": "Administre y personalice los diseños de página para adaptarlos a las necesidades de su organización. Cree nuevas configuraciones, defina tipos y controle si se heredan los ajustes de la organización principal.",
    "useParentPageConfigurations": "Heredar configuraciones de la página de la organización principal",
    "type": "Tipo",
    "pageConfigurationTypes": {
      "INDIVIDUAL": "Individual",
      "NON_INDIVIDUAL": "No individual",
      "ACCOUNT": "Cuenta",
      "GOAL": "Meta",
      "HOUSEHOLD": "Hogar",
      "SUB_ACCOUNT": "Subcuenta",
      "ACCOUNT_GROUP": "Grupo de cuentas"
    }
  },
  "homePageConfigurations": {
    "title": "Configuraciones de la página de inicio",
    "description": "Administre y personalice los diseños de página de inicio para adaptarlos a las necesidades de su organización. Cree nuevas configuraciones, defina widgets y controle si se heredan los ajustes de la organización principal.",
    "useParentHomePageConfigurations": "Heredar configuraciones de la página de inicio de la organización principal",
    "table": {
      "name": "Nombre",
      "widgetCount": "Número de widgets",
      "organization": "Organización",
      "createdAt": "Creado en"
    }
  },
  "staticPageWidgetConfigurations": {
    "title": "Configuraciones del widget de página estática",
    "description": "Administre y personalice los diseños de página estática de widgets para adaptarlos a las necesidades de su organización. Cree nuevas configuraciones, defina tipos y controle si se heredan los ajustes de la organización principal.",
    "useParentStaticPageWidgetConfigurations": "Heredar configuraciones de la página estática de widgets de la organización principal",
    "model": "Configuración del Widget de Página Estática"
  },
  "workflows": {
    "title": "Flujos de trabajo",
    "description": "Cree, administre y personalice flujos de trabajo para automatizar procesos clave. Defina los estados, los desencadenantes y las secuencias de pasos del flujo de trabajo para optimizar la incorporación de clientes, las aprobaciones y otras tareas operativas.",
    "useParentWorkflows": "Heredar flujos de trabajo de la organización principal",
    "states": "Estados",
    "workflowStates": {
      "DRAFT": "Borrador",
      "ACTIVE": "Activo",
      "ARCHIVED": "Archivado"
    }
  },
  "customFields": {
    "title": "Campos personalizables",
    "description": "Cree y administre campos personalizables para capturar datos adicionales específicos para las necesidades de su organización. Defina los tipos de campos, los objetos asociados y aplique reglas condicionales para mejorar la estructura de los datos y la facilidad de uso.",
    "useParentCustomFields": "Heredar campos personalizables de la organización principal"
  },
  "clientReports": {
    "title": "Reportes de cliente",
    "description": "Configure los reportes de clientes para que muestren información específica de cada cliente, incluyendo saldos de cuentas, transacciones y métricas de rendimiento.",
    "useParentClientReports": "Heredar reportes de clientes de la organización principal"
  },
  "downtimeSchedule": {
    "title": "Calendario de inactividad",
    "description": "Cree y administre tiempos de inactividad programados para el mantenimiento de la plataforma. Defina las plataformas afectadas, las horas de inicio y finalización, y especifique exclusiones basadas en roles para controlar el impacto en los usuarios."
  },
  "newsAndInsights": {
    "title": "Novedades e información",
    "description": "Administre y publique artículos para mantener informados a los usuarios. Elija entre heredar contenido de la organización principal o subir información personalizada relevante para su público.",
    "useParentArticles": "Heredar artículos de la organización principal"
  },
  "tradingSchedules": {
    "title": "Horarios de transacción",
    "description": "Administre y configure los horarios de negociación para alinearlos con las estrategias de inversión. Vea los horarios existentes, actualice las fechas y cree nuevos horarios para controlar el momento de ejecución de las operaciones.",
    "useParentSchedules": "Heredar horarios de transacción de la organización principal"
  },
  "assetClasses": {
    "title": "Clases de activos",
    "description": "Administre y personalice las clases de activos utilizadas en la construcción de carteras. Visualice, edite y añada clasificaciones para alinearlas con las estrategias de inversión. Elija heredar las clases de activos de la organización matriz.",
    "useParentAssetClasses": "Heredar las clases de activos de la organización principal"
  },
  "feeGrids": {
    "title": "Tablas de tarifas",
    "description": "Defina y gestione estructuras de comisiones, incluidos modelos escalonados y combinados. Configure cálculos de activos bajo gestión facturables y ajustes de comisiones predeterminados.",
    "useParentFeeGrids": "Heredar tablas de tarifas de la organización principal",
    "configureTitle": "Configurar Tabla de Tarifas",
    "settingsSectionTitle": "Configuración",
    "noEntities": "Ninguna entidad está utilizando esta tabla de tarifas.",
    "defaultFallbackBanner": "Esta es la tabla de tarifas predeterminada. Se aplica a todas las entidades como respaldo incluso sin una asignación explícita, por lo que algunas entidades que la utilizan pueden no aparecer en esta lista.",
    "inheritedParentBanner": "Esta tabla de tarifas se hereda de una organización principal. Las entidades asignadas a ella a nivel principal no son visibles aquí.",
    "unassign": "Desasignar",
    "unassignSuccess": "Tabla de tarifas desasignada con éxito.",
    "unassignError": "Error al desasignar la tabla de tarifas.",
    "tabs": {
      "subAccount": "Subcuenta",
      "account": "Cuenta",
      "accountGroup": "Grupo de Cuentas",
      "user": "Usuario",
      "clientGroup": "Grupo de Clientes"
    },
    "createTitle": "Crear Tabla de Tarifas",
    "createBeforeAssignTitle": "Primero cree una tabla de tarifas",
    "createBeforeAssignBody": "Una vez guardada, usted podrá asignarle entidades.",
    "entityPlural": {
      "subAccount": "subcuentas",
      "account": "cuentas",
      "accountGroup": "grupos de cuentas",
      "user": "usuarios",
      "clientGroup": "grupos de clientes"
    },
    "assign": "Asignar",
    "assigned": "Asignado(s)",
    "assignedToOtherGrid": "Asignado a otra tabla",
    "assignEntityModalTitle": "Asignar entidad",
    "assignSearchPlaceholder": "Buscar por nombre",
    "assignSearchByIdPlaceholder": "Buscar por ID",
    "assignNoResults": "No se encontraron entidades coincidentes.",
    "assignSuccess": "Tabla de tarifas asignada con éxito.",
    "assignError": "Error al asignar la tabla de tarifas.",
    "assignArchivedTooltip": "Las entidades archivadas o inactivas no se pueden asignar."
  },
  "billingSchedules": {
    "title": "Calendarios de facturación",
    "description": "Configure calendarios con fechas de cálculo y facturación. Defina calendarios predeterminados y configure reglas de procesamiento de tarifas.",
    "useParentBillingSchedules": "Heredar horarios de facturación de la organización principal",
    "configureTitle": "Configurar Calendario de Facturación",
    "createTitle": "Crear Calendario de Facturación",
    "createBeforeAssignTitle": "Primero cree un calendario de facturación",
    "createBeforeAssignBody": "Una vez guardado, usted podrá asignarle entidades.",
    "settingsSectionTitle": "Configuración",
    "noEntities": "Ninguna {{entity}} está utilizando este calendario de facturación.",
    "entityPlural": {
      "subAccount": "subcuentas",
      "account": "cuentas",
      "accountGroup": "grupos de cuentas",
      "user": "usuarios",
      "clientGroup": "grupos de clientes"
    },
    "defaultFallbackBanner": "Este es el calendario de facturación predeterminado. Se aplica a todas las entidades como respaldo incluso sin una asignación explícita, por lo que algunas entidades que lo utilizan pueden no aparecer en esta lista.",
    "inheritedParentBanner": "Este calendario de facturación se hereda de una organización principal. Las entidades asignadas a él a nivel principal no son visibles aquí.",
    "assign": "Asignar",
    "assigned": "Asignado(s)",
    "assignedToOtherSchedule": "Asignado a otro calendario",
    "assignEntityModalTitle": "Asignar entidad",
    "assignSearchPlaceholder": "Buscar por nombre",
    "assignSearchByIdPlaceholder": "Buscar por ID",
    "assignNoResults": "No se encontraron entidades coincidentes.",
    "assignArchivedTooltip": "Las entidades archivadas o inactivas no se pueden asignar.",
    "assignSuccess": "Calendario de facturación asignado con éxito.",
    "assignError": "Error al asignar el calendario de facturación.",
    "unassign": "Desasignar",
    "unassignSuccess": "Calendario de facturación desasignado con éxito.",
    "unassignError": "Error al desasignar el calendario de facturación.",
    "tabs": {
      "subAccount": "Subcuenta",
      "account": "Cuenta",
      "accountGroup": "Grupo de Cuentas",
      "user": "Usuario",
      "clientGroup": "Grupo de Clientes"
    }
  },
  "integrations": {
    "title": "Integraciones",
    "description": "Administre y agregue conexiones de terceros a la plataforma. Los usuarios pueden ver, heredar o crear nuevas integraciones seleccionando un tipo (por ejemplo, banca, análisis, verificación de identidad). Estas integraciones ayudan a optimizar el intercambio de datos y mejoran la funcionalidad de la plataforma.",
    "useParentIntegrations": "Heredar integraciones de la organización principal"
  },
  "localizations": {
    "title": "Localizaciones",
    "description": "Configure los ajustes específicos de cada región, como las jurisdicciones habilitadas, los formatos de identificación fiscal y las preferencias de visualización de la moneda, para garantizar el cumplimiento normativo y la coherencia en todos los mercados.",
    "useParentLocalizations": "Heredar localizaciones de la organización principal"
  },
  "apiTokens": {
    "title": "Tokens API",
    "description": "Cree y administre claves de acceso seguras para integraciones de sistemas. Los usuarios pueden definir permisos (lectura, escritura, transición) para diversas entidades, como clientes, roles y productos financieros, lo que garantiza un acceso controlado a los datos."
  },
  "webhooks": {
    "title": "Webhooks",
    "description": "Los webhooks permiten enviar notificaciones de eventos en tiempo real a sistemas externos. Los usuarios pueden configurar activadores, especificar destinos y personalizar cargas útiles para automatizar flujos de trabajo y mantener los datos sincronizados entre plataformas.",
    "useParentWebhooks": "Heredar webhooks de la organización principal"
  },
  "bulkImport": {
    "title": "Importación masiva",
    "description": "Inicie nuevas importaciones de datos y supervise los trabajos de importación en curso o completados. Proporciona información sobre el estado del procesamiento, incluidos los registros en cola, fallidos e importados correctamente."
  },
  "transfers": {
    "title": "Transferencias",
    "description": "Configure los ajustes de transferencia, incluidos los requisitos de revisión de transacciones, la prevención del fraude y los límites mínimos de depósito. Establezca los periodos de retención de efectivo antes de que se puedan retirar o negociar los fondos.",
    "cashOnHoldToWithdrawDays": "Número de días que hay que mantener el efectivo antes de poder retirarlo",
    "cashOnHoldToTradeDays": "Número de días que se debe mantener el efectivo antes de poder negociarlo",
    "cancelTransferCutoffDays": "Número de días antes de una transferencia programada pendiente en los que no se puede cancelar una transferencia programada",
    "reviewTransactions": "Revisar transacciones",
    "blockSuspiciousTransactions": "Bloquear transacciones sospechosas",
    "minInitialDepositCents": "Depósito inicial mínimo",
    "minRecurringDepositCents": "Depósito mínimo programado (único, recurrente)",
    "minDepositCents": "Depósito mínimo",
    "enableFullCashTransfers": "Habilitar transferencias de efectivo totales",
    "enablePartialCashTransfers": "Habilitar transferencias de efectivo parciales",
    "enableAllInKindTransfers": "Habilitar todo tipo de transferencias",
    "minInitialDepositCentsError": "El depósito inicial mínimo debe ser mayor que 1",
    "minRecurringDepositCentsError": "El depósito programado mínimo debe ser mayor que 1",
    "minDepositCentsError": "El depósito mínimo debe ser mayor que 1"
  },
  "trades": {
    "title": "Transacciones",
    "description": "Configure los ajustes de ejecución de operaciones, como inversiones automáticas, edición de operaciones tras la optimización y procesos de negociación predeterminados.",
    "allowPostOptimizationEditing": "Permitir la edición de operaciones después de la optimización",
    "defaultTradingProcess": "Proceso de negociación predeterminado",
    "requireSubTradeRequestApproval": "Se requiere verificación comercial",
    "allowViewSubTradeRequestPairs": "Permitir ver pares de solicitudes de subcomercio",
    "bulkTradingProcess": "Proceso predeterminado de negociación masiva",
    "defaultDriftTolerancePercent": "Tolerancia de desviación predeterminada (%)",
    "driftRecalculationInProgress": "Recálculo de desviación en curso. El campo de tolerancia de desviación está temporalmente deshabilitado mientras se reevalúan las carteras. Otros ajustes aún se pueden guardar.",
    "driftRecalculationComplete": "Recálculo de desviación completado.",
    "driftConfirmTitle": "¿Aplicar nueva tolerancia de desviación?",
    "driftConfirmBody": "Cambiar la tolerancia de desviación predeterminada activará un recálculo en cada cartera de su organización. Esto puede tardar varios minutos en completarse.",
    "driftConfirmApply": "Aplicar y recalcular",
    "driftRangeHint": "Ingrese un valor entre 5-20%",
    "driftRangeError": "El valor no es válido y debe estar entre 5-20%",
    "optimizerProcess": "Motor Optimizador",
    "optimizerProcessTooltip": "Se aplica solo a las carteras que utilizan el proceso de negociación del optimizador de Cartera."
  },
  "compliance": {
    "title": "Cumplimiento",
    "description": "Defina los ajustes de cumplimiento para garantizar el cumplimiento normativo. Configure los requisitos de aprobación de cuentas, la verificación de identidad, las actualizaciones anuales de información y las restricciones sobre usuarios y transacciones inactivos.",
    "allowInactiveUserRebalancing": "Permitir el reequilibrio de usuarios inactivos",
    "allowInactiveUserFeeCalculation": "Permitir que se calculen las tarifas a los usuarios inactivos",
    "allowInactiveUserAdjustments": "Permitir que se realicen ajustes a los usuarios inactivos",
    "allowInstantInvest": "Permitir la inversión instantánea",
    "requireManualAccountApproval": "Requerir aprobación manual de la cuenta",
    "requireSubTradeRequestApproval": "Requerir aprobación de solicitud de subcontratación",
    "profileReviewTimeInMonths": "Tiempo de revisión del perfil (en meses)"
  },
  "portfolioManagementSettings": {
    "title": "Configuración de la gestión de carteras",
    "description": "Configure las preferencias de gestión de carteras, como la herencia de estantes de productos, carteras modelo y temas. Active o desactive funciones como transacciones pendientes, compensación de pérdidas fiscales y operaciones fijas para alinearlas con las estrategias de inversión.",
    "useParentProductShelf": "Heredar la estantería de productos de la organización principal",
    "useParentModelPortfolios": "Heredar carteras modelo de la organización matriz",
    "useParentThemes": "Heredar temas de la organización principal",
    "allowPortfolioPerGoal": "Permitir que la cartera se ajuste al objetivo",
    "allowPendingTransactions": "Permitir transacciones pendientes",
    "disableStatsUpdateBasedOnTransactions": "Desactivar la actualización de estadísticas basada en transacciones",
    "useHistoricalSnapshotsCutOffDate": "Habilitar fecha límite para datos históricos",
    "historicalSnapshotsCutOffDate": "Fecha límite de los datos históricos",
    "historicalSnapshotsCutOffDateInfo": "Las transacciones posteriores a esta fecha límite se incluirán en el cálculo de las posiciones. Las transacciones anteriores a esta fecha se excluirán. Las posiciones de referencia deben proporcionarse en la fecha límite para establecer el estado inicial (efectivo, tenencias y base de costo).",
    "disableRebalanceReport": "Desactivar el cálculo del informe de reequilibrio",
    "hideAutoUpdatePrices": "Ocultar precios de actualización automática",
    "enableManualUpdateExchangeRates": "Habilitar actualización manual de tipos de cambio",
    "enableAutoUpdateExchangeRates": "Habilitar actualización automática de tipos de cambio",
    "marketValueDipThresholdPercentage": "Umbral de porcentaje de caída del valor de mercado para bandera (%)",
    "marketValueDipThresholdPercentageInfo": "Caída del valor de mercado día a día que activa una bandera durante la conciliación. Mínimo 5%, el valor predeterminado es 15% si no se establece.",
    "marketValueDipThresholdPercentageMinError": "Debe ser al menos 5%"
  },
  "feeSettings": {
    "title": "Configuración de tarifas",
    "description": "Configure los ajustes relacionados con las comisiones, como la posibilidad de cobrar comisiones administrativas a los clientes y exigir la aprobación de las comisiones.",
    "chargeAdminFeesToClient": "Cobrar tarifas administrativas al cliente",
    "requireFeeApproval": "Se requiere aprobación de tarifa",
    "allowChargePST": "Permitir cargo de PST",
    "enableFees": "Habilitar tarifas"
  },
  "embedded": {
    "title": "Incrustado",
    "description": "Configure cómo funciona la plataforma cuando se integra en otra aplicación. Los usuarios pueden establecer una URL de clave JWT para una autenticación segura y elegir si desean mostrar la barra de menú cuando se incrusta.",
    "jwtKeyUrl": "URL clave de JWT",
    "displayMenuBar": "Mostrar barra de menús cuando está incrustado"
  },
  "roleSettings": {
    "title": "Configuración de los roles",
    "description": "Establezca las funciones predeterminadas para los usuarios cuando se registren, incluidas la función predeterminada de registro, la función predeterminada de asesor y la función predeterminada de cliente. Esto permite personalizar las funciones de los usuarios en función de los requisitos de la organización.",
    "defaultSignUpRole": "Rol predeterminado al registrarse",
    "defaultAdvisorRole": "Rol predeterminado del asesor",
    "defaultClientRole": "Rol predeterminado del cliente"
  },
  "accounts": {
    "title": "Cuentas",
    "description": "Habilite o deshabilite los tipos de cuentas disponibles en la plataforma, incluyendo, entre otras, cuentas individuales, corporativas y registradas. Configure los permisos para diferentes estructuras de cuentas en función de los requisitos de la organización."
  },
  "accountSettings": {
    "title": "Configuración de la cuenta",
    "description": "Configure los ajustes relacionados con la cuenta, como los ajustes de las operaciones de afiliados."
  },
  "taxRankings": {
    "title": "Clasificaciones fiscales",
    "description": "Establezca las clasificaciones fiscales para las cuentas disponibles en la plataforma.",
    "useParentTaxRanks": "Utilizar las clasificaciones fiscales del padre/madre"
  },
  "generalProductExperience": {
    "title": "General",
    "description": "Configure los ajustes esenciales para su experiencia con el producto, como comportamientos predeterminados y preferencias generales."
  },
  "formDefinitions": {
    "title": "Definiciones de formularios",
    "description": "Administre las definiciones de formularios y sus configuraciones de su organización",
    "definitions": "Definiciones",
    "signerTypes": "Tipos de firmantes",
    "useParentFormDefinitions": "Heredar definiciones de formulario de la organización principal",
    "table": {
      "key": "Clave",
      "name": "Nombre",
      "type": "Tipo",
      "objectType": "Tipo de objeto",
      "state": "Estado",
      "actions": "Acciones"
    },
    "state": {
      "DRAFT": "Borrador",
      "ACTIVE": "Activo",
      "ARCHIVED": "Archivado"
    },
    "objectType": {
      "ACCOUNT": "Cuenta",
      "SUB_ACCOUNT": "Subcuenta",
      "ENTITY": "Entidad",
      "GOAL": "Meta",
      "HOUSEHOLD": "Hogar"
    },
    "formDefinitionModal": {
      "title": "Nueva definición del formulario",
      "editTitle": "Editar definición del formulario",
      "key": "Clave",
      "name": "Nombre",
      "description": "Descripción",
      "pdfFileNameTemplate": "Nombre del archivo PDF",
      "pdfFileNameTemplateHelper": "Plantilla Handlebars para el nombre del archivo (p. ej. {{user.lastName}}_{{user.firstName}}_NCAF)",
      "objectType": "Tipo de objeto",
      "type": "Tipo",
      "ENTITY": "Entidad",
      "SUB_ACCOUNT": "Subcuenta",
      "ACCOUNT": "Cuenta",
      "GOAL": "Meta",
      "HOUSEHOLD": "Hogar",
      "PDF_IN_APP": "PDF: firma en la aplicación",
      "NONE_UPLOAD": "Solo carga",
      "PDF_UPLOAD": "PDF - Cargar",
      "PDF_INTEGRATION": "PDF - Integración",
      "template": "Plantilla del formulario",
      "basicTemplate": "Formulario cargado",
      "externalTemplate": "Formulario completado externamente",
      "url": "URL externa",
      "apiToken": "Token API",
      "signerKey": "Clave del firmante",
      "pageNumber": "Página #",
      "x": "Posición X",
      "y": "Posición Y",
      "fillingType": "Tipo de Relleno",
      "FILLING_TYPE_NONE": "Ninguno",
      "FILLING_TYPE_FORM_MAP": "Mapa de Formulario",
      "FILLING_TYPE_WEBHOOK": "Webhook",
      "FILLING_TYPE_STATIC": "Estático",
      "formMaps": "Mapas de Formulario",
      "noFormMaps": "No hay mapas de formulario configurados para esta definición.",
      "formMapRow": "Mapa de Formulario creado el {{date}} en {{language}}",
      "addFormMap": "Agregar Mapa de Formulario"
    },
    "signers": "Firmantes"
  },
  "signerTypes": {
    "title": "Tipos de firmantes",
    "description": "Administre los tipos de firmantes y sus configuraciones de su organización",
    "useParentSignerTypes": "Heredar tipos de firmantes de la organización principal",
    "table": {
      "key": "Clave",
      "name": "Nombre",
      "isPrimary": "Es el principal",
      "defaultSigningOrder": "Orden de firma predeterminada",
      "primary": "Principal",
      "secondary": "Secundario"
    },
    "signerTypeModal": {
      "title": "Nuevo tipo de firmante",
      "editTitle": "Editar tipo de firmante",
      "key": "Clave",
      "name": "Nombre",
      "isPrimary": "Es el principal",
      "defaultSigningOrder": "Orden de firma predeterminada"
    },
    "editSignerTypeModal": {
      "title": "Editar tipo de firmante",
      "key": "Clave",
      "name": "Nombre",
      "isPrimary": "Es el principal",
      "defaultSigningOrder": "Orden de firma predeterminada"
    }
  },
  "custodianConnections": {
    "title": "Conexiones de Custodios",
    "description": "Administre las conexiones de custodios para su organización. Configure conexiones a custodios para operaciones, gestión de cuentas y sincronización de datos.",
    "useParentCustodianConnections": "Heredar conexiones de custodios de la organización principal",
    "table": {
      "name": "Nombre",
      "type": "Tipo",
      "default": "Predeterminado",
      "organization": "Organización",
      "actions": "Acciones",
      "inherited": "Heredado",
      "yes": "Sí"
    },
    "types": {
      "APEX": "Apex",
      "ATB": "ATB",
      "CIBC_MELLON": "CIBC Mellon",
      "CIIS": "CIIS",
      "ENVESTNET": "Envestnet",
      "FC": "FC",
      "FUNDSERV": "Fundserv",
      "IBKR": "IBKR",
      "NBIN": "NBIN",
      "NO_CONNECTION": "Sin conexión",
      "PERSHING": "Pershing",
      "RBC": "RBC",
      "SCHWAB": "Schwab"
    },
    "modal": {
      "createTitle": "Nueva conexión de custodio",
      "editTitle": "Editar conexión de custodio",
      "name": "Nombre",
      "type": "Tipo",
      "customerName": "Nombre del cliente",
      "repCode": "Código de representante",
      "default": "Conexión predeterminada",
      "updateSuccess": "Conexión de custodio actualizada con éxito"
    },
    "detail": {
      "breadcrumb": "Conexión de Custodio",
      "description": "Configure esta conexión de custodio {{type}}",
      "notFound": "Conexión de custodio no encontrada",
      "saveSuccess": "Conexión de custodio actualizada con éxito",
      "tabs": {
        "basicInfo": "Información Básica",
        "accountTypeSettings": "Tipos de Cuenta",
        "sftpCredentials": "Credenciales SFTP",
        "config": "Configuración",
        "featureFlags": "Indicadores de Características"
      },
      "basicInfo": {
        "title": "General",
        "description": "Configuración principal de identificación y conexión"
      },
      "submissionSettings": {
        "title": "Envío y Reconciliación",
        "description": "Configure cómo se envían y concilian las transacciones, transferencias y aperturas de cuentas"
      },
      "reconciliationType": "Tipo de Reconciliación",
      "transferSubmissionType": "Tipo de Envío de Transferencia",
      "accountOpeningSubmissionType": "Tipo de Envío de Apertura de Cuenta",
      "notificationEmails": "Correos Electrónicos de Notificación",
      "notificationEmailsHelper": "Lista de direcciones de correo electrónico separadas por comas",
      "accountTypes": {
        "title": "Configuración de Tipos de Cuenta",
        "addAccountType": "Agregar Tipo de Cuenta",
        "removeAccountType": "Eliminar",
        "newAccountType": "Nuevo Tipo de Cuenta",
        "empty": "No hay configuraciones de tipo de cuenta. Agregue una para definir la moneda y la configuración de afiliados por tipo de cuenta.",
        "accountType": "Tipo de Cuenta",
        "baseCurrency": "Moneda Base",
        "availableCurrencies": "Monedas Disponibles",
        "enableMultiCurrency": "Habilitar Multimoneda",
        "enableAutoSweep": "Habilitar Barrido Automático",
        "multiCurrency": "Multimoneda",
        "affiliateSettings": "Configuración de Afiliados",
        "addAffiliate": "Agregar Afiliado",
        "affiliateType": "Tipo de Afiliado",
        "affiliateDescription": "Descripción",
        "requiredFields": "Campos Obligatorios",
        "optionalFields": "Campos Opcionales"
      },
      "sftp": {
        "title": "Credenciales SFTP",
        "inbound": "Entrada (SFTP de Entrada)",
        "inboundDescription": "Credenciales para descargar archivos del custodio",
        "outbound": "Salida (SFTP de Salida)",
        "outboundDescription": "Credenciales para subir archivos al custodio",
        "authenticationType": "Tipo de Autenticación",
        "authTypes": {
          "USERNAME_PASSWORD": "Nombre de Usuario y Contraseña",
          "PRIVATE_KEY": "Clave Privada"
        },
        "host": "Host",
        "port": "Puerto",
        "username": "Nombre de Usuario",
        "password": "Contraseña",
        "privateKey": "Clave Privada",
        "passphrase": "Frase de Contraseña",
        "sourceDir": "Directorio de Origen",
        "targetPrefix": "Prefijo de Destino",
        "targetDir": "Directorio de Destino",
        "bucket": "Bucket S3",
        "bucketVariableName": "Nombre de Variable del Bucket",
        "serverHostKey": "Tipos de Clave de Host del Servidor"
      },
      "config": {
        "title": "Configuración de Conexión",
        "description": "Configuración JSON genérica para esta conexión de custodio. Esto es específico del custodio y varía según el tipo de integración.",
        "invalidJson": "Formato JSON no válido"
      },
      "flags": {
        "title": "Indicadores de Características",
        "groups": {
          "import": "Importación de Datos",
          "reconciliation": "Reconciliación",
          "submission": "Envío",
          "transfers": "Transferencias de Depósito",
          "fetching": "Obtención de Datos",
          "trading": "Transacciones y Cuentas",
          "filePaths": "Rutas de Archivos de Importación"
        },
        "enableCustodianActivityImport": "Importación de Actividad",
        "enableCustodianSnapshotImport": "Importación de Instantáneas",
        "enableCustodianAccountImport": "Importación de Cuentas",
        "enableCustodianUserImport": "Importación de Usuarios",
        "enableCustodianOrganizationImport": "Importación de Organizaciones",
        "enableCustodianOrganizationUserImport": "Importación de Usuarios de la Organización",
        "enableCustodianCredentialsManager": "Administrador de Credenciales",
        "enableAutoReconcileActivities": "Reconciliar Actividades Automáticamente",
        "enableAutoReconcilePositions": "Reconciliar Posiciones Automáticamente",
        "enableTransferSubmission": "Envío de Transferencias",
        "enableAccountOpeningSubmission": "Envío de Apertura de Cuentas",
        "enableCancelCustodianDepositTransfer": "Cancelar Transferencia de Depósito",
        "enableChallengedCustodianDepositTransfer": "Transferencia de Depósito Impugnada",
        "enableCreateCustodianDepositTransfers": "Crear Transferencias de Depósito",
        "enableSaveInternalRecordsOfCustodianDepositTransfers": "Guardar Registros Internos de Transferencias de Depósito",
        "enableFetchCustodianStatistics": "Obtener Estadísticas",
        "enableFetchCustodianSuitability": "Obtener Idoneidad",
        "enableFetchCustodianSnapshotHistory": "Obtener Historial de Instantáneas",
        "enableFetchCustodianTransactions": "Obtener Transacciones",
        "enableFetchCustodianAffiliates": "Obtener Afiliados",
        "enableFetchCustodianBankAccounts": "Obtener Cuentas Bancarias",
        "enableFetchCustodianUpcomingTransactions": "Obtener Próximas Transacciones",
        "enableFetchCustodianStatements": "Obtener Estados de Cuenta",
        "enableFetchCustodianCustomFields": "Obtener Campos Personalizables",
        "enableFetchCustodianProjectedIncome": "Obtener Ingresos Proyectados",
        "enableFetchCustodianNotifications": "Obtener Notificaciones",
        "allowCashAsDepositTarget": "Permitir Efectivo como Objetivo de Depósito",
        "allowFractionalTrading": "Permitir Negociación Fraccionada",
        "allowTransactionCreation": "Permitir Creación de Transacciones",
        "disableCorpInventoryAccount": "Deshabilitar Cuenta de Inventario Corporativo",
        "fetchLivePrices": "Obtener Precios en Tiempo Real",
        "custodianActivityImportFilePaths": "Rutas de Archivos de Importación de Actividad",
        "custodianSnapshotImportFilePaths": "Rutas de Archivos de Importación de Instantáneas",
        "custodianUsersImportFilePath": "Ruta de Archivo de Importación de Usuarios",
        "filePathsHelper": "Lista de rutas de archivo separadas por comas"
      },
      "reconciliationTypes": {
        "FULL": "Completa",
        "HYBRID": "Híbrida",
        "READ_ONLY": "Solo lectura"
      },
      "transferSubmissionTypes": {
        "BATCH": "Por lotes",
        "EVENT": "Por evento"
      },
      "accountOpeningTypes": {
        "BATCH": "Por lotes",
        "EVENT": "Por evento"
      }
    },
    "modelName": "conexión de custodio"
  },
  "featureFlags": {
    "title": "Indicadores de características",
    "description": "Administre los indicadores de funciones para controlar las características y el comportamiento de la plataforma. Active o desactive funciones específicas según los requisitos de la organización."
  },
  "bulkTradingProcessOptions": {
    "pair": "EMPAREJAR",
    "bucket": "CATEGORÍA"
  },
  "customAttributeLabels": {
    "title": "Etiquetas de atributos personalizables",
    "editTitle": "Editar etiquetas de atributos personalizables",
    "description": "Cree y administre etiquetas de atributos personalizadas para su organización",
    "objectType": "Tipo de objeto",
    "name": "Nombre del atributo",
    "options": {
      "label": "Etiqueta",
      "options": "Opciones",
      "description": "Descripción",
      "value": "Valor"
    },
    "useParentCustomAttributeLabels": "Heredar etiquetas de atributos personalizables de la organización principal",
    "attributeNames": {
      "RISK_QUESTION_1": "Pregunta sobre riesgos 1",
      "RISK_QUESTION_2": "Pregunta sobre riesgos 2",
      "GOAL_RISK_QUESTION_1": "Pregunta sobre el riesgo del objetivo 1",
      "TIME_HORIZON": "Horizonte temporal",
      "INVESTMENT_KNOWLEDGE": "Conocimientos sobre inversiones"
    },
    "buttons": {
      "add": "Añadir"
    },
    "states": {
      "ACTIVE": "Activo",
      "ARCHIVED": "Archivado",
      "INACTIVE": "Inactivo"
    },
    "objectTypes": {
      "GOAL": "Meta",
      "USER": "Usuario"
    },
    "table": {
      "attribute": "Nombre del atributo",
      "objectType": "Tipo de objeto",
      "state": "Estado",
      "organization": "Organización",
      "actions": "Acciones"
    },
    "actions": {
      "activate": "Activar",
      "archive": "Archivar",
      "deactivate": "Desactivar"
    },
    "validation": {
      "optionsRequired": "Se requiere al menos una opción"
    }
  },
  "workflowUpload": {
    "button": "Cargar",
    "success": "¡Flujo de trabajo creado correctamente!",
    "error": "Error al crear el flujo de trabajo",
    "validationError": "Error de validación",
    "validationMessage": "El archivo JSON cargado presenta los siguientes problemas:",
    "invalidJsonFile": "Archivo JSON no válido. Por favor, revise el formato del archivo.",
    "missingName": "Falta un campo obligatorio: nombre",
    "missingNameEn": "Falta un campo obligatorio: nombre.en (Nombre en inglés)",
    "missingSteps": "Falta un campo obligatorio: pasos",
    "stepsMustBeArray": "El campo \"pasos\" debe ser un conjunto",
    "workflowMustHaveStep": "El flujo de trabajo debe tener al menos un paso",
    "stepMissingName": "Paso {{index}}: Falta el campo obligatorio \"nombre\"",
    "stepMissingNameEn": "Paso {{index}}: Falta el campo obligatorio \"nombre.en\"",
    "stepMissingSubSteps": "Paso {{index}}: Falta el campo obligatorio \"pasos secundarios\"",
    "stepSubStepsMustBeArray": "Paso {{index}}: El campo \"pasos secundarios\" debe ser un conjunto",
    "subStepMissingType": "Paso {{stepIndex}}, Paso secundario {{subStepIndex}}: Falta el campo obligatorio \"tipo\"",
    "usedIn": "Usado en: {{title}}",
    "uploadError": "Error de carga",
    "confirmTitle": "Cargar flujo de trabajo",
    "confirmMessage": "¿Confirma que desea crear un nuevo flujo de trabajo a partir de este archivo?",
    "create": "Crear flujo de trabajo",
    "fileName": "Archivo",
    "workflowName": "Nombre del flujo de trabajo",
    "steps": "Pasos",
    "trigger": "Activar",
    "mapRoleProfiles": "Asignar perfiles de roles",
    "roleMappingMessage": "El flujo de trabajo cargado contiene perfiles de roles. Asigne estos perfiles a los perfiles de roles existentes en su organización:",
    "mapTo": "Asignar a un perfil del rol existente",
    "selectRoleProfile": "Seleccionar perfiles de roles",
    "noRoleProfilesTitle": "No hay perfiles de roles disponibles para asignar",
    "noRoleProfilesMessage": "El flujo de trabajo cargado contiene perfiles de roles, pero no hay perfiles de roles disponibles en su organización para asignarlos.",
    "noRoleProfilesHint": "Puede crear primero los perfiles de roles necesarios o desvincular todos los perfiles de roles para continuar.",
    "requiredRoleProfiles": "Perfiles de roles requeridos por este flujo de trabajo:",
    "unlinkAllRoleProfiles": "Desvincule todos los perfiles de roles (establezca todos los rolesCompletadosPor en vacío)",
    "roleProfilesMapped": "Perfiles de roles",
    "allRoleProfilesUnlinked": "Todos los perfiles de roles se desvincularán (rolesCompletadosPor se establecerá en vacío)",
    "mapCustomFields": "Asignar campos personalizables",
    "customFieldMappingMessage": "El flujo de trabajo cargado contiene campos personalizables. Asigne estos campos a los campos personalizados existentes en su organización:",
    "mapToCustomField": "Asignar a un campo personalizable existente",
    "selectCustomField": "Seleccionar campo personalizable",
    "noCustomFieldsTitle": "No hay campos personalizables disponibles para asignar",
    "noCustomFieldsMessage": "El flujo de trabajo cargado contiene campos personalizables, pero no hay campos personalizados disponibles en su organización para asignarlos.",
    "noCustomFieldsHint": "Puede crear primero los campos personalizables necesarios o desvincular todos los campos personalizables para continuar.",
    "requiredCustomFields": "Campos personalizables requeridos por este flujo de trabajo:",
    "unlinkAllCustomFields": "Desvincule todos los campos personalizables (elimine las configuraciones de los campos personalizables)",
    "customFieldsMapped": "Campos personalizables",
    "allCustomFieldsUnlinked": "Se eliminarán todas las configuraciones de campos personalizables de las opciones"
  },
  "pageConfigUpload": {
    "button": "Cargar",
    "success": "¡Configuración de página creada correctamente!",
    "error": "Error al crear la configuración de la página",
    "validationError": "Error de validación",
    "validationMessage": "El archivo JSON cargado presenta los siguientes problemas:",
    "invalidJsonFile": "Archivo JSON no válido. Por favor, revise el formato del archivo.",
    "missingPageConfiguration": "Falta el campo obligatorio: configuración de página",
    "missingName": "Falta un campo obligatorio: nombre",
    "missingType": "Falta un campo obligatorio: tipo",
    "missingTabs": "Falta un campo obligatorio: pestañas",
    "tabsMustBeArray": "El campo \"pestañas\" debe ser un conjunto",
    "tabMissingLabel": "Pestaña {{index}}: Falta el campo obligatorio \"etiqueta\"",
    "tabMissingWidgets": "Pestaña {{index}}: Falta el campo obligatorio \"widgets\"",
    "tabWidgetsMustBeArray": "Pestaña {{index}}: El campo \"widgets\" debe ser un conjunto",
    "widgetMissingType": "Pestaña {{tabIndex}}, Widget {{widgetIndex}}: Falta el campo obligatorio \"tipo\"",
    "usedIn": "Usado en: {{title}}",
    "uploadError": "Error de carga",
    "workflowWarning": "Advertencia de flujo de trabajo",
    "confirmTitle": "Cargar la onfiguración de la página",
    "confirmMessage": "¿Confirma que desea crear una nueva configuración de página a partir de este archivo?",
    "create": "Crear configuración de la página",
    "fileName": "Archivo",
    "name": "Nombre",
    "type": "Tipo",
    "tabs": "Pestañas",
    "mapWorkflows": "Asignar flujos de trabajo",
    "workflowMappingMessage": "La configuración de la página cargada contiene referencias al flujo de trabajo. Asigne estas referencias a los flujos de trabajo existentes en su organización:",
    "selectWorkflow": "Seleccionar flujo de trabajo",
    "noWorkflowsTitle": "No hay flujos de trabajo disponibles para asignar",
    "noWorkflowsMessage": "La configuración de la página cargada contiene referencias de flujos de trabajo, pero no hay flujos de trabajo disponibles en su organización para asignar.",
    "noWorkflowsHint": "Las referencias del flujo de trabajo se establecerán en \"predeterminado\". Puede actualizarlas después de crear la configuración de la página.",
    "workflowsInConfig": "Flujos de trabajo en esta configuración:",
    "workflowsMapped": "Flujos de trabajo asignados",
    "mapCustomFields": "Asignar campos personalizables",
    "customFieldMappingMessage": "La configuración de la página cargada contiene campos personalizables. Asigne estos campos a los campos personalizables existentes en su organización:",
    "selectCustomField": "Seleccionar campo personalizables",
    "noCustomFieldsTitle": "No hay campos personalizables disponibles para asignar",
    "noCustomFieldsMessage": "La configuración de la página cargada contiene campos personalizables, pero no hay campos personalizables disponibles en su organización para asignarlos.",
    "noCustomFieldsHint": "Puede crear primero los campos personalizables necesarios o desvincular todos los campos personalizables para continuar.",
    "requiredCustomFields": "Campos personalizables obligatorios:",
    "unlinkAllCustomFields": "Desvincule todos los campos personalizables (elimine las configuraciones de los campos personalizables)",
    "customFieldsMapped": "Campos personalizables",
    "allCustomFieldsUnlinked": "Se eliminarán todas las configuraciones de campos personalizables"
  },
  "textDesigner": {
    "description": "",
    "title": "Variantes de Texto",
    "loading": "Cargando la configuración del diseñador de texto…",
    "loadError": "Error al cargar la configuración del diseñador de texto",
    "textVariants": "Variantes de Texto",
    "changeOrgLevelText": "Personalice la tipografía (fuente, tamaño, peso, color) para encabezados, texto del cuerpo y etiquetas. Los cambios se aplican en toda su organización y son visibles para los clientes.",
    "fontSize": "Tamaño de Fuente",
    "fontSizeHelp": "ej., 16px, 1.5rem",
    "fontFamily": "Familia de Fuente",
    "fontFamilyHelp": "ej., Inter, Arial, sans-serif",
    "color": "Color",
    "fontWeight": "Peso de Fuente",
    "fontWeightHelp": "ej., 400, 600, 700",
    "letterSpacing": "Espaciado entre Letras",
    "letterSpacingHelp": "ej., 0px, -0.25px",
    "lineHeight": "Altura de Línea",
    "lineHeightHelp": "ej., 24px, 1.5",
    "apply": "Aplicar",
    "applyConfirmTitle": "¿Aplicar cambios en las variantes de texto?",
    "applyConfirmMessage": "Estos cambios serán visibles inmediatamente para los clientes. La tipografía se actualizará en toda la aplicación después de que usted confirme.",
    "validationFontWeight": "El peso de la fuente debe ser un número entre 1 y 1000 (ej., 400, 700).",
    "validationLetterSpacing": "Use una longitud (ej., 0px, -0.25px, 0.1em) o la palabra \"normal\".",
    "validationLineHeight": "Use un número (ej., 1.5), una longitud (ej., 24px) o la palabra \"normal\".",
    "validationColor": "Ingrese un color hexadecimal válido (ej., #000000 o #fff).",
    "validationFontSize": "Use una longitud con unidad (ej., 16px, 1.5rem, 42px)."
  },
  "alertBanners": {
    "title": "Banner de Alerta",
    "description": "Los banners de alerta aparecen en la parte superior de la pantalla, justo debajo del encabezado, y están destinados a mensajes oportunos y de alto valor, como avisos de mantenimiento programado o anuncios de nuevas funciones. Para mantener una experiencia limpia y enfocada, es mejor mantener el número de banners activos al mínimo. Utilice el rango de fechas para controlar cuándo se muestra un banner."
  },
  "flagPolicies": {
    "title": "Políticas de Indicadores",
    "description": "Configure el comportamiento de los indicadores de conciliación para esta organización. Vea las políticas efectivas, incluyendo las heredadas y las predeterminadas de la plataforma, luego anule el estado habilitado, la prioridad y los umbrales de cantidad por tipo de indicador.",
    "noAccess": "Usted no tiene permiso para ver la configuración de las políticas de indicadores.",
    "searchPlaceholder": "Buscar tipos de indicadores",
    "noResults": "Ningún tipo de indicador coincide con su búsqueda.",
    "config": {
      "priority": "Prioridad",
      "thresholdCents": "Umbral (centavos)",
      "thresholdPercent": "Umbral (%)",
      "thresholdDollars": "Umbral ($)"
    },
    "validation": {
      "duplicatePolicy": "Las políticas de indicadores contienen tipos de indicadores duplicados.",
      "duplicateThreshold": "Los umbrales de indicadores contienen tipos de indicadores duplicados.",
      "policyRowIncomplete": "Cada anulación de política de indicador debe establecer el estado habilitado y/o la prioridad.",
      "invalidPriority": "La prioridad debe ser Crítica, Alta, Media o Baja.",
      "thresholdRowIncomplete": "Cada anulación de umbral debe establecer el umbral en centavos y/o el umbral en porcentaje.",
      "negativeThresholdCents": "El umbral en centavos debe ser cero o mayor.",
      "invalidPercentThreshold": "El umbral en porcentaje debe estar entre 0 y 100.",
      "percentOnlyNoCents": "Este tipo de indicador solo admite un umbral en porcentaje."
    },
    "futureFlagsNotice": "Los cambios en la criticidad de la política de indicadores solo se aplicarán a los indicadores futuros. Los indicadores existentes no se verán afectados.",
    "priorityChangeConfirm": {
      "title": "¿Cambiar la prioridad del indicador?",
      "body": "Actualizar la criticidad de este indicador de reequilibrio cambiará la forma en que se muestra y se actúa sobre él en toda la plataforma. Por favor, confirme que esto es intencional."
    }
  },
  "accountGroupSettings": {
    "title": "Configuración de Grupos de Cuentas",
    "description": "Configure los ajustes a nivel de organización para los grupos de cuentas.",
    "enableAutoArchive": "Habilitar el archivado automático de grupos de cuentas",
    "stopDateCustomField": {
      "label": "Campo personalizable de fecha de finalización",
      "placeholder": "Ninguno",
      "helperText": "Seleccione el campo personalizable de fecha en los grupos de cuentas que determina cuándo un grupo debe archivarse automáticamente."
    }
  }
}
